/**
 * Dev-only deprecation notice, so a host still passing a frozen runtime finds out
 * from its own console rather than from a 0.1.0 changelog. Silent in production
 * builds: the value still works, and a warning per render is noise, not signal.
 */
function warnDeprecatedRuntime(subject, advice) {
    if (process.env.NODE_ENV === "production")
        return;
    // eslint-disable-next-line no-console
    console.warn(`[runtimePolicy] ${subject} is deprecated: ${advice}`);
}
export function evaluateRuntimePolicy(input) {
    const requested = input.engineRuntime ?? "fork";
    // "auto" is a deprecated alias of fork (tool-lane fallback removed in L5 —
    // fork covers all tools since L1). Kept so hosts still passing it keep working.
    if (requested === "auto") {
        warnDeprecatedRuntime('engineRuntime="auto"', 'resolving fork. Pass "fork" explicitly.');
        return {
            resolvedRuntime: "fork",
            reasonCode: "AUTO_DEFAULT_FORK_RUNTIME",
        };
    }
    // The type no longer admits "legacy", but a host is JavaScript at runtime and can
    // pass the string anyway. Anything that is not literally "fork" resolves to fork,
    // so this function can never return a runtime it is unable to render. Without
    // this clamp it would hand back "legacy" and every caller would take a lane that
    // no longer exists.
    const reasonCode = input.engineRuntime === undefined
        ? "DEFAULT_FORK_RUNTIME"
        : "EXPLICIT_FORK_REQUEST";
    return {
        resolvedRuntime: "fork",
        reasonCode,
    };
}
/**
 * @deprecated Always `false` since the legacy lane was removed on 2026-10-03.
 * Removed from the public API in the same release that dropped DynamicChart.
 */
export function shouldForceLegacyRuntime(_input) {
    return false;
}
export function resolveRequestedRuntime(input) {
    return evaluateRuntimePolicy(input).resolvedRuntime;
}
